import { connect } from 'react-redux';

import Toolbar from '~/Components/Pages/Lists/Toolbar';
import { sortList } from '~/Context/Global';

import { createList, deleteList, setCurrent, unsetCurrent } from '~/Redux/Modules/UserLists';

const mapStateToProps = ({ UserLists: { lists } }) => {
  return {
    userLists: sortList(lists.data, 'updated_at', true),
    current: lists.current,
    fetched: lists.fetched,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    createList: data => dispatch(createList(data)),
    deleteList: data => dispatch(deleteList(data)),
    unsetCurrent: () => dispatch(unsetCurrent()),
    setCurrent: data => dispatch(setCurrent(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Toolbar);
